export const RH_EVENT_ORIGIN = 'https://popup.schedulehero.io';

export const IPINFO_URL = 'https://ipinfo.io/?token=61f50ad7b00677';
